import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { GetPartCollectionApiParameter, GetWholegoodCollectionApiParameter } from "@store/Services/PartsService";
import { getBaseDataView } from "@store/Store/Data/DataState";
import { PartsDataView } from "@store/Store/Data/Parts/PartsState";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { PartViewModel } from "@store/Types/Parts";

export function getPartsDataView(state: StoreApplicationState, getPartsParameter?: GetPartCollectionApiParameter) {
    return getBaseDataView(state.store.data.parts, {type: "parts", ...getPartsParameter});
}

export function getPartsViewModel(state: StoreApplicationState, dataView: PartsDataView) {
    const viewModel = dataView?.parts?.map(
        part =>
            ({
                ...part,
                product: getProductState(state, part.productId).value,
            } as PartViewModel),
    );
    return viewModel;
}

export function getWholegoodsDataView(state: StoreApplicationState, getWholegoodsParameter?: GetWholegoodCollectionApiParameter) {
    return getBaseDataView(state.store.data.parts, {type: "wholegoods", ...getWholegoodsParameter});
}

export function getWholegoodsViewModel(state: StoreApplicationState, dataView: PartsDataView) {
    const viewModel = dataView?.wholegoods?.map(
        wholegood => wholegood as ProductModel,
    );
    return viewModel;
}
